import { CardMedia, Grid } from '@material-ui/core';
import usePortalStyles from '../../../layouts/PortalLayout/usePortalStyles';
import usePublic from '../../../utilities/usePublic';

const SignUpHeader = () => {
    const portalStyles = usePortalStyles();
    const eurokarsPreOwned = usePublic('assets/images/eurokarsPreOwned.svg');

    return (
        <Grid xs={12} item>
            <CardMedia className={portalStyles.logo} image={eurokarsPreOwned} />
        </Grid>
    );
};

export default SignUpHeader;
